import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import { relativeNdviInfo } from '@/constants/layers/wfasLayerInfo'

export default {
  id: 'relativeNDVI',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms?sevice=wms',
  title: {
    'en-US': 'Relative NDVI',
    'pt-BR': 'NDVI Relativa',
    'es-ES': 'NDVI Relativa',
    'fr-FR': 'NDVI relatif'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'reference', info: relativeNdviInfo },
  opacity: 0.5,
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'wfas:current_ndvi_fracmax',
      visible: true,
      legend: {
        title: {
          'en-US': 'Relative NDVI',
          'pt-BR': 'NDVI Relativa',
          'es-ES': 'NDVI Relativa',
          'fr-FR': 'NDVI relatif'
        },
        items: [
          {
            text: {
              'en-US': 'No Data',
              'pt-BR': 'Sem dados',
              'es-ES': 'Sin Datos',
              'fr-FR': 'Aucune donnée'
            },
            color: '#ff0000',
            icon: 'mdi-close'
          },
          {
            type: 'ramp',
            items: [
              {
                text: {
                  'en-US': 'Minimum',
                  'pt-BR': 'Mínima',
                  'es-ES': 'Mínima',
                  'fr-FR': 'Minimum'
                },
                color: '#ffffff',
                ratio: 0.01
              },
              {
                text: {
                  'en-US': 'Less than 0.2',
                  'pt-BR': 'Menos de 0.2',
                  'es-ES': 'Menos de 0.2',
                  'fr-FR': 'Moins de 0.2'
                },
                color: '#d73027',
                ratio: 0.16
              },
              {
                text: {
                  'en-US': '0.2 to 0.3',
                  'pt-BR': '0.2 a 0.3',
                  'es-ES': '0.2 a 0.3',
                  'fr-FR': '0.2 à 0.3'
                },
                color: '#fc8d59',
                ratio: 0.33
              },
              {
                text: {
                  'en-US': '0.3 to 0.5',
                  'pt-BR': '0.3 a 0.5',
                  'es-ES': '0.3 a 0.5',
                  'fr-FR': '0.3 à 0.5'
                },
                color: '#fee08b',
                ratio: 0.5
              },
              {
                text: {
                  'en-US': '0.5 to 0.7',
                  'pt-BR': '0.5 a 0.7',
                  'es-ES': '0.5 a 0.7',
                  'fr-FR': '0.5 à 0.7'
                },
                color: '#d9ef8b',
                ratio: 0.66
              },
              {
                text: {
                  'en-US': '0.7 to 0.9',
                  'pt-BR': '0.7 a 0.9',
                  'es-ES': '0.7 a 0.9',
                  'fr-FR': '0.7 à 0.9'
                },
                color: '#91cf60',
                ratio: 0.83
              },
              {
                text: {
                  'en-US': 'More than 0.9',
                  'pt-BR': 'Mais de 0.9',
                  'es-ES': 'Más de 0.9',
                  'fr-FR': 'Plus de 0.9'
                },
                color: '#1a9850',
                ratio: 1
              }
            ]
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
} as LayerRaw
